import Head from 'next/head';

import Header from '@/components/Header';
import Footer from '@/components/Footer';
import { MarketingPartnersList } from '@/components/MarketingPartnersList';

const MarketingPartners = () => {
  return (
    <div className="page-wrapper">
      <Head>
        <meta name="description" content="CallAPro - Find a Home Service Professional Near You" />
        <title>Find Home Service Pros Near You</title>
      </Head>
      <Header />
      <MarketingPartnersList />
      <Footer />
    </div>
  );
};

export default MarketingPartners;
